(() => {
  const nativeFor = host => {
    const pageProduct = window.linxNativeProduct;
    if (pageProduct?.managedBy === 'shopify') return pageProduct;
    const title = host.querySelector('.product-single__title, h2')?.textContent?.replace(/\s+/g, ' ').trim();
    return (window.linxManagedProducts || []).map(entry => entry.published).find(product =>
      product?.managedBy === 'shopify' && title && (product.name === title || title.includes(product.name.replace(/\s*0-52-34$/, '')))
    ) || null;
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('#add-preview');
    if (!button) return;
    const host = button.closest('#product-body, #dialog-content') || document;
    const product = nativeFor(host);
    if (!product || !window.linxCart) return;

    const selectedTitle = host.querySelector('[data-variant][aria-pressed="true"]')?.textContent?.trim();
    const variant = product.variants.find(item => item.title === selectedTitle) || product.variants[0];
    const quantity = Math.max(1, Math.floor(Number(host.querySelector('input[type="number"]')?.value) || 1));
    if (!variant?.available) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    button.textContent = 'Adding\u2026';
    try {
      await window.linxCart.add(String(variant.id), quantity);
    } catch (error) {
      const feedback = document.createElement('p');
      feedback.setAttribute('role', 'alert');
      feedback.textContent = error.message || 'The item could not be added. Please try again.';
      button.after(feedback);
    } finally {
      button.disabled = false;
      button.textContent = 'Add to cart';
    }
  }, true);
})();
